import { render } from "./CustomTabView.vue?vue&type=template&id=441fa7ac"
import script from "./CustomTabView.vue?vue&type=script&lang=js"
export * from "./CustomTabView.vue?vue&type=script&lang=js"

import "./CustomTabView.vue?vue&type=style&index=0&id=441fa7ac&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/common/infrastructure/componentes/base/common/controles/CustomTabView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "441fa7ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('441fa7ac', __exports__)) {
    api.reload('441fa7ac', __exports__)
  }
  
  module.hot.accept("./CustomTabView.vue?vue&type=template&id=441fa7ac", () => {
    api.rerender('441fa7ac', render)
  })

}


export default __exports__